import { Popconfirm } from 'antd';
import React from 'react';

import { IPageJumpConfirmation } from '@components/common/PageJumpConfirmation/typed';

export const PageJumpConfirmation: React.FC<IPageJumpConfirmation> = ({
  pageValidationEnabled,
  onCancel,
  children,
}) => {
  if (pageValidationEnabled) {
    return (
      <Popconfirm
        title="You have unsaved changes, are you sure you want to leave?"
        okButtonProps={{
          type: 'default',
          style: {
            color: '#0046ff',
            borderColor: '#0044ff',
          },
        }}
        okText="Stay"
        cancelButtonProps={{ danger: true, style: { color: '#ff4d4f' } }}
        cancelText="Leave without saving"
        placement="bottomRight"
        onCancel={onCancel}
      >
        {children}
      </Popconfirm>
    );
  }
  return <>{children}</>;
};
